<template>
  <div class="wrapper">
    <div class="grid">
      <h1>404 Not Found</h1>
    </div>
  </div>
</template>

<script>
  export default {
    name: "404",
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style scoped>

</style>
